import { renderBuildAuthorshipDataFieldsContentTemplate } from '@next-adapter/templates/renderers/generators/actions/action-helpers/build-authorship-data-fields.js'
export function buildAuthorshipDataFields(): string {
  return renderBuildAuthorshipDataFieldsContentTemplate()
}
